export default __webpack_public_path__ + "static/media/left_bottom.b9f5558a.png";